// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3enzJ","index":"styles_index__36DEW"};